import React          from 'react';
import ReactDom       from 'react-dom';
import Moment         from 'moment';

import Const          from 'fw_const';
import Utils          from 'utils';

import Card           from '@common/influencer/_card';
import RegisterModal  from '@common/influencer-search/register/register-modal';
// -------------------------------------------------------

const API_COUNT = 10;

class List extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    this.state = {
      modal : false,
    };
  }
  // -------------------------------------------------------
  
  /*
   * データ編集
   */
  toggleModal(flg) {
    this.setState({ modal: flg });
    
    if( flg == true  ) Utils.fixedContents();
    if( flg == false ) Utils.unlockFixedContents();
    
    if( flg == false ) this.props.refresh_ev.bind(this)('register');
  }
  // -------------------------------------------------------
  
  render() {
    let data = this.props.data;
    if( data == undefined ) data = {};
    
    let base = this.props.base;
    
    return (
      <div className="influencer-register-contents">
        <div className="buttons">
          <div className="button" onClick={this.toggleModal.bind(this, true)}><span className="material-icons">person_add</span>インフルエンサーを新規登録する</div>
          
          <a className="button" href="/influencer-discovery" target="_blank"><span className="material-icons">zoom_in</span>新規調査する</a>
        </div>
        
        <h3 className="search-result">登録したアカウントリスト (※直近100件まで)</h3>
        <div className="influencer-list">
          { data.items.map((d, key) => {
            return (
              <Card key={key} data={d} base={base} list={data.items} multi_action_flg={true} />
            );
          })}
        </div>
        
        <RegisterModal view={this.state.modal} register_mode="search-box" close_ev={this.toggleModal.bind(this)} />
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default List;